import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Device } from './device.model';
import { DateUtils } from 'ng-jhipster';
import {DeviceReport} from './device.model';
@Injectable()
export class DeviceService {

    private resourceUrl = 'api/devices';
    private resourceSearchUrl = 'api/_search/devices';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(device: Device): Observable<Device> {
        let copy: Device = Object.assign({}, device);
        copy.activationDate = this.dateUtils.toDate(device.activationDate);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(device: Device): Observable<Device> {
        let copy: Device = Object.assign({}, device);

        copy.activationDate = this.dateUtils.toDate(device.activationDate);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Device> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.activationDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.activationDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }
    addMany(devices: any): Observable<DeviceReport[]> {
        let copy: any = Object.assign( {}, devices );
        return this.http.post( this.resourceUrl+"/addMany", copy ).map( (res: Response) => {
            return res.json();
        } );
    }
    deleteMany(devices: any): Observable<DeviceReport[]> {
        let copy: any = Object.assign( {}, devices );
        return this.http.post( this.resourceUrl+"/deleteMany", copy ).map( (res: Response) => {
            return res.json();
        } );
    }

    search(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].activationDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].activationDate);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/device/device.service.ts